
import {useMemo} from "react";
import * as THREE from "three";

// Improved lens flare - now it will render in front of everything
export function Flare({ position }) {
    // Use a texture for the flare points
    const flareTexture = useMemo(() => {
        const canvas = document.createElement('canvas');
        canvas.width = 128;
        canvas.height = 128;
        const ctx = canvas.getContext('2d');

        // Create a radial gradient for a more realistic flare point
        const gradient = ctx.createRadialGradient(64, 64, 0, 64, 64, 64);
        gradient.addColorStop(0, 'rgba(255, 255, 255, 1.0)');
        gradient.addColorStop(0.5, 'rgba(255, 240, 200, 0.5)');
        gradient.addColorStop(1, 'rgba(255, 210, 160, 0.0)');

        ctx.fillStyle = gradient;
        ctx.fillRect(0, 0, 128, 128);

        return new THREE.CanvasTexture(canvas);
    }, []);

    // Position the flare using position from props
    return (
        <group position={position}>
            {/* Main central flare */}
            <sprite scale={[4, 4, 1]} renderOrder={1000}>
                <spriteMaterial
                    map={flareTexture}
                    transparent={true}
                    opacity={0.8}
                    depthWrite={false}
                    depthTest={false} // This ensures it renders over everything
                    blending={THREE.AdditiveBlending}
                />
            </sprite>

            {/* Additional flare points along a line */}
            {[-6, -3, 3, 6].map((distance, i) => (
                <sprite
                    key={i}
                    position={[distance * 0.8, distance * 0.5, 0]}
                    scale={[2 + (3 - Math.abs(distance/2)), 2 + (3 - Math.abs(distance/2)), 1]}
                    renderOrder={1000}
                >
                    <spriteMaterial
                        map={flareTexture}
                        transparent={true}
                        opacity={0.3 - Math.abs(distance) * 0.02}
                        depthWrite={false}
                        depthTest={false} // This ensures it renders over everything
                        blending={THREE.AdditiveBlending}
                        color={i % 2 === 0 ? "#ffcc88" : "#88ccff"}
                    />
                </sprite>
            ))}
        </group>
    );
}